module.exports = __webpack_public_path__ + "static/beep-1e394afa97f95d9d85a383c46e2e55fe.mp3";